import React from 'react';
import './SiteLogo.scss';
import { useContentful } from '../contentful/ContentContext';

type SiteLogoProps = {
  size: 'small' | 'large';
  color: 'orange' | 'white';
};

const SiteLogo = ({ size, color }: SiteLogoProps) => {
  const { getUiText } = useContentful();
  const title = getUiText('UI.SiteTitle') ?? 'Urjord Keramik';

  return (
    <span className={`siteLogo siteLogo--${size} siteLogo--${color}`}>
      {title}
    </span>
  );
};

export default SiteLogo;
